<template>
    <span>
        <editarcardapio></editarcardapio>
    </span>
</template>

<script>
import Editarcardapio from '@/components/Editar-Cardapio';

export default {
    name: 'cadeditarcardapio',
    components: {
        Editarcardapio
    }
};
</script>